mutation ChangeDataUploadRowDecision(
  $id: ID!
  $decision: DataUploadRowDecision!
) {
  changeDataUploadRowDecision(input: { id: $id, decision: $decision }) {
    success
  }
}
